import { Button, ButtonProps, Tooltip } from "@mui/material";

export default function TooltipButton({
  tooltipText,
  ButtonElement = Button,
  ...props
}: ButtonProps & {
  tooltipText?: string | React.ReactNode;
  ButtonElement?: React.ComponentType<ButtonProps>;
}): React.ReactElement {
  if (!tooltipText) {
    return <ButtonElement {...props} />;
  }

  const width = props.fullWidth ? "100%" : "fit-content";

  return (
    <Tooltip title={tooltipText}>
      {/* We need the span because disable buttons don' fire hover events */}
      <span style={{ width: width }}>
        <Button {...props} />
      </span>
    </Tooltip>
  );
}
